import React, { useEffect, useState } from 'react'
import './EnterPriseReport.css'
import Ribbon from '../../../core/common/ribbon/ribbon';
import { useGetEnterpriseReportQuery, useGetProjectLookupsQuery, useLazyGetEnterpriseReportQuery, useLazyGetTeamMembersEmailQuery, useSendEmailMutation } from '../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import html2pdf from 'html2pdf.js';
import RichTextEditor from '../../../core/common/Rich Text Editor/RichTextEditor';
import ModalComponent from '../../../core/common/modal/ModalComponent';
import TextField from '../../../core/common/textFields/TextField';
import Select from 'react-select';
import { customStyles } from '../../../core/common/Custom Style/CustomStyle';
import { DatePicker } from 'antd';
import dayjs from "dayjs";
import TableLoading from '../../../core/common/loadingComponent/TableLoading';
const EnterPriseReport = ({ projectId }: any) => {
    const { data: projectLookups, refetch: projectLookupsRefetch } = useGetProjectLookupsQuery('');
    const [triggerEnterprise, { data: enterpriseData, isFetching }] = useLazyGetEnterpriseReportQuery();
    const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(null)
    const generateDummyRow = () => {
        const row = [];
        for (let i = 0; i < 6; i++) {
            row.push({
                count: Math.floor(Math.random() * 10) + 1,
                volume: `$${(Math.random() * 1500000 + 100000).toLocaleString()}`,
            });
        }
        return row;
    };
    const sections = [
        {
            title: "Opportunity Management",
            actions: [
                "All Contacts Created",
                "All First Appts Scheduled",
                "All Non-Cancelled First Appts Scheduled",
                "Sales: Non-Cancelled First Appts Run",
                "Sales: All Non-Cancelled First GoBacks",
            ],
        },
        {
            title: "Sale/Offer Management",
            actions: [
                "Written Sales (Based on Sale Date)",
                "Stuck Sales (Based on Sale Date)",
                "Contractual Review Completed",
                "Specs Review Completed",
                "Sale Accepted",
            ],
        },
        {
            title: "Project Development",
            actions: [
                "Permits Submitted",
                "Permits Received",
                "ECD Reviewed",
                "Ready for DRC",
                "DRC Signoff",
                "Ready for PCC",
                "PCC Signoff",
                "Projects Sent to Purchasing",
                "Projects Readied for Construction",
            ],
        },
        {
            title: "Production",
            actions: [
                "Projects Started In Construction",
                "Projects Substantially Completed",
                "Projects Completed",
            ],
        },
    ];

    const initialValues = {
        Subject: "",
        InternalEmailAddresses: [
            {
                id: 0,
                value: "",
            },
        ],
        ExternalEmailAddresses: [""],
        Body: "",
        Attachments: [] as { name: string; data: ArrayBuffer }[],
    };
    const formik = useFormik({
        initialValues,
        // validationSchema: loginSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("Subject", values.Subject);
            formData.append(
                "InternalEmailAddresses",
                values.InternalEmailAddresses.map((item) => item.value).toString()
            );
            formData.append(
                "ExternalEmailAddresses",
                values.ExternalEmailAddresses.toString()
            );
            formData.append("Body", values.Body);
            values.Attachments.forEach(({ name, data }, index) => {
                const fileBlob = new Blob([data], { type: "application/pdf" });
                formData.append(`Attachments`, fileBlob, name);
            });
            try {
                await sendEmail(formData).unwrap();
                toast.success("File uploaded successfully");
                formik.resetForm();
                setShowModal(false);
            } catch (error) {
                console.error("Error uploading file:", error);
            }
        },
    });
    const [showModal, setShowModal] = useState(false);
    const [modalTitlePopup, setModalTitlePopup] = useState("");
    const [noteDescription, setNoteDescription] = useState("");

    //email api
    const [sendEmail, { data: sendEmailData, isSuccess, isLoading: isLoadingEmail }] =
        useSendEmailMutation();
    //getTeam Member Email
    const [
        triggerTeamsMember,
        { data: getTeamMembers, isSuccess: isSuccessEmail },
    ] = useLazyGetTeamMembersEmailQuery();

    const [emails, setEmails] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState("");
    const [fileData, setFileData] = useState<File[]>([]);

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const decodeHtml = (html: any) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && inputValue.trim()) {
            e.preventDefault();
            const email = inputValue.trim();

            if (
                isValidEmail(email) &&
                !formik.values.ExternalEmailAddresses.includes(email)
            ) {
                formik.setFieldValue("ExternalEmailAddresses", [
                    ...formik.values.ExternalEmailAddresses.filter(
                        (email: string) => email !== ""
                    ),
                    email,
                ]);
                setInputValue("");
            }
        }
    };
    const removeEmail = (email: string) => {
        const filteredEmails = formik.values.ExternalEmailAddresses.filter(
            (e: string) => e !== email
        );
        formik.setFieldValue("ExternalEmailAddresses", filteredEmails);
    };
    const handleSave = () => {
        formik.handleSubmit();
    };
    const handleGetTeamMembers = () => {
        triggerTeamsMember({ projectId: projectId });
    };
    const handleClose = () => {
        setShowModal(false);
        formik.resetForm();
    };
    const selectValues = formik.values?.InternalEmailAddresses
        ? formik.values.InternalEmailAddresses.filter(
            (users: { id: number; value: string }) =>
                users.id !== 0 && users.value !== ""
        ).map((users: { id: number; value: string }) => ({
            value: users?.id,
            label: users?.value,
        }))
        : [];

    const handleChange = (newValue: any) => {
        const updatedValues = newValue.map(
            (option: { value: any; label: any }) => ({
                id: option.value,
                value: option.label,
            })
        );

        formik.setFieldValue("InternalEmailAddresses", updatedValues);
    };

    const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            const fileArray = Array.from(files);
            setFileData(fileArray);
            formik.setFieldValue("Attachments", fileArray);
        }
    };

    useEffect(() => {
        if (getTeamMembers?.result && isSuccessEmail) {
            formik.setFieldValue(
                "InternalEmailAddresses",
                getTeamMembers.result.map((member: any) => {
                    return {
                        id: member.id,
                        value: member.value,
                    };
                })
            );
        }
    }, [getTeamMembers?.result, isSuccessEmail]);
    const [ispdfLoading, setPdfIsLoading] = useState(false);

    const downloadPDF = async () => {
        const dynamicFileName = `Enterprise_Weekly_Report.pdf`;
        const content = document.getElementById("enterprise-content");
        if (!content) {
            setPdfIsLoading(false);
            return;
        }
        const options = {
            margin: 0,
            filename: dynamicFileName,
            html2canvas: { scale: 5, useCORS: true },
            jsPDF: { unit: "px", format: [1000, 1100], pagebreak: { mode: ['avoid-all'] }, orientation: "landscape" },
        };
        setPdfIsLoading(true);
        try {
            await html2pdf().set(options).from(content).save();
        } catch (error) {
        } finally {
            setPdfIsLoading(false);
        }
    };

    const handleGeneratePDFAddenda = async () => {
        const content = document.getElementById("enterprise-content");
        if (!content) {
            console.error("Element not found:", "enterprise-content");
            return;
        }

        const options = {
            margin: 0,
            filename: `Enterprise_Weekly_Report.pdf`,
            html2canvas: { scale: 5, useCORS: true },
            jsPDF: { unit: "px", format: [1000, 1100], pagebreak: { mode: ['avoid-all'] }, orientation: "landscape" },
        };

        try {
            const pdfBlob = await html2pdf()
                .set(options)
                .from(content)
                .toPdf()
                .output("blob");
            const arrayBuffer = await pdfBlob.arrayBuffer();
            formik.setFieldValue("Attachments", [
                { name: `Enterprise_Weekly_Report.pdf`, data: arrayBuffer },
            ]);
        } catch (error) {

        }
    };
    const handleEmailAddenda = () => {
        setModalTitlePopup(`Enterprise Weekly Report Email`);
        setShowModal(true);
        handleGeneratePDFAddenda();
    };

    return (
        <>
            <ModalComponent
                buttonText="Send"
                modalTitle={modalTitlePopup}
                onClose={handleClose}
                onSave={handleSave}
                isVisible={showModal}
                cancelButton="Cancel"
                saveButton="Send"
            >
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="input-label">
                                <TextField
                                    label="Subject"
                                    required
                                    type="text"
                                    {...formik.getFieldProps("Subject")}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label>Internal Users</label>
                                    {/* <button
                                        className="btn btn-primary mb-1 mt-1 fs-11"
                                        onClick={handleGetTeamMembers}
                                    >
                                        Get Team Members
                                    </button> */}
                                </div>
                                <Select
                                    isMulti={true}
                                    styles={customStyles}
                                    className="select multi-select"
                                    options={
                                        projectLookups?.result?.ActiveUserEmail?.map(
                                            (option: any) => ({
                                                label: option?.value,
                                                value: option?.id,
                                            })
                                        ) || []
                                    }
                                    value={selectValues}
                                    onChange={(newValue: any) => handleChange(newValue)}
                                />
                            </div>
                            <div className="col-md-12">
                                <div className="d-flex justify-content-between">
                                    <label className="input-label">External Users</label>
                                </div>
                                <div className="email-input-container">
                                    <div className="badges-container">
                                        {formik.values.ExternalEmailAddresses[0] !== "" ? (
                                            formik.values.ExternalEmailAddresses.map(
                                                (email: string, index: number) => (
                                                    <span
                                                        key={index}
                                                        className="badge badge-pill badge-primary me-2"
                                                    >
                                                        {email}{" "}
                                                        <button
                                                            type="button"
                                                            className="btn-close ms-1"
                                                            onClick={() => removeEmail(email)}
                                                        >
                                                            &times;
                                                        </button>
                                                    </span>
                                                )
                                            )
                                        ) : (
                                            <span className="text-muted">...</span>
                                        )}
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter email and Press enter"
                                            value={inputValue}
                                            onChange={(e) => setInputValue(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                            disabled
                                        />
                                    </div>
                                    {formik.errors.ExternalEmailAddresses && (
                                        <div className="text-danger">
                                            {formik.errors.ExternalEmailAddresses}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-12">
                                <RichTextEditor
                                    value={formik.values.Body}
                                    name="Message"
                                    onChange={(value: any) => formik.setFieldValue("Body", value)}
                                />
                            </div>
                            <label className="input-label mt-2"> Attachments</label>
                            <div className="br-gray p-2 bg-lightGray">
                                <p>{formik.values.Attachments[0]?.name}</p>
                            </div>
                        </div>
                    </div>
                </>
            </ModalComponent>
            <div className="page-wrapper">
                <div className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className='card'>
                                <div className='card-body p-2'>
                                    <div className='d-flex justify-content-end gap-3 align-items-center'>
                                        <h5 className='color-red'>Please Select Date to show Enterprise report</h5>
                                        <div className='w-25'>
                                            <DatePicker
                                                className="form-control datetimepicker deals-details"
                                                onChange={(date: any) => {
                                                    if (date) {
                                                        const formattedDate = dayjs(date).format("YYYY-MM-DD");
                                                        triggerEnterprise({ startDate: formattedDate });
                                                        setSelectedDate(dayjs(date))
                                                    }
                                                }}
                                                value={selectedDate}
                                                format="MMM-DD-YYYY"
                                                allowClear={false}
                                                disabledDate={(current) => {
                                                    return current && current > dayjs().endOf('day');
                                                }}
                                            />
                                        </div>

                                        <button className='btn btn-primary' onClick={downloadPDF}>
                                            {`${ispdfLoading ? "Downloading pdf ...." : "DownLoad PDF"}`}
                                        </button>
                                        <button className='btn btn-primary' onClick={handleEmailAddenda}>
                                            Send To Email
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-9'></div>
                        {isFetching ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
                                <TableLoading />
                            </div>
                        ) :
                            enterpriseData?.result?.reportYearVMs.length > 0 ? (
                                <div className='col-md-8 col-lg-8'>
                                    <div className='card' id='enterprise-content' style={{ width: "1100px" }}>
                                        <div className='card-body'>
                                            <h4 className='text-center mb-2'>Enterprise Weekly Operational Report ({enterpriseData?.result?.weekDetailLine})</h4>
                                            <>
                                                <table className="table table-bordered table-sm text-center align-middle enterprise-table">
                                                    <thead>
                                                        {/* <tr className="table-dark bg-gray">
                                                    <th></th>
                                                    <th colSpan={6} className=''>{enterpriseData?.result?.reportYearVMs.[0]?.yearName}</th>
                                                    <th colSpan={6} className=''>{enterpriseData?.result?.reportYearVMs.[1]?.yearName}</th>
                                                </tr> */}
                                                        {/* second way to do  */}
                                                        <tr className="table-dark bg-gray">
                                                            <th ></th>
                                                            {enterpriseData?.result?.reportYearVMs.map((yearGroup: any, idx: number) => (
                                                                <th
                                                                    key={idx}
                                                                    colSpan={yearGroup.reportHeaders.length * 2}
                                                                    className="bg-gray text-white text-center"
                                                                >
                                                                    {yearGroup.yearName}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                        {/* <tr className="table-dark bg-gray">
                                                    <th>Action Name</th>
                                                    it is for first year ..
                                                    <th className='' colSpan={2}>{enterpriseData?.result?.reportYearVMs.[0]?.reportHeaders[0]?.headerName}</th>
                                                    <th className='' colSpan={2}>{enterpriseData?.result?.reportYearVMs.[0]?.reportHeaders[1]?.headerName}</th>
                                                    <th className='' colSpan={2}>{enterpriseData?.result?.reportYearVMs.[0]?.reportHeaders[2]?.headerName}</th>
                                                    it is for second year ..
                                                    <th className='' colSpan={2}>{enterpriseData?.result?.reportYearVMs.[1]?.reportHeaders[0]?.headerName}</th>
                                                    <th className='' colSpan={2}>{enterpriseData?.result?.reportYearVMs.[1]?.reportHeaders[1]?.headerName}</th>
                                                    <th className='' colSpan={2}>{enterpriseData?.result?.reportYearVMs.[1]?.reportHeaders[2]?.headerName}</th>
                                                </tr> */}
                                                        {/* second way to do  */}
                                                        <tr className="table-dark bg-gray">
                                                            <th>Action Name</th>
                                                            {enterpriseData?.result?.reportYearVMs.map((yearGroup: any) =>
                                                                yearGroup?.reportHeaders?.map((period: any, idx: number) => (
                                                                    <th key={`${yearGroup.year}-${idx}`} colSpan={2} className="bg-gray text-white text-center">
                                                                        {period?.headerName}
                                                                    </th>
                                                                ))
                                                            )}
                                                        </tr>
                                                        {/* <tr className="table-secondary bg-gray bg-gray">
                                                    <th></th>
                                                    {Array(6 * 2).fill(0).map((_, i) => (
                                                        <th key={i}>{i % 2 === 0 ? 'Count' : 'Volume'}</th>
                                                    ))}
                                                </tr> */}
                                                        <tr className="table-secondary bg-gray">
                                                            <th></th>
                                                            {enterpriseData?.result?.reportYearVMs.map((yearData: any) =>
                                                                yearData.reportHeaders.flatMap((header: any) => [
                                                                    <th key={`count-${header.headerName}`}>Count</th>,
                                                                    <th key={`volume-${header.headerName}`}>Volume</th>
                                                                ])
                                                            )}
                                                        </tr>

                                                    </thead>
                                                    <tbody>
                                                        {/* Get unique groups from first year (assuming same groups exist in all years) */}
                                                        {enterpriseData?.result?.reportYearVMs[0]?.reportHeaders?.[0]?.reportGroups?.map((group: any, groupIdx: number) => (
                                                            <React.Fragment key={`group-${groupIdx}`}>
                                                                <tr className="table-light fw-bold text-start section-header">
                                                                    <td colSpan={13}>{group?.groupName}</td>
                                                                </tr>
                                                                {group?.subHeadings?.map((sub: any, subIdx: number) => (
                                                                    <tr key={`action-${subIdx}`}>
                                                                        <td className="text-start subsection-header">{sub?.actionName}</td>
                                                                        {/* For each year */}
                                                                        {enterpriseData?.result?.reportYearVMs.map((yearGroup: any) => (
                                                                            // For each period in this year
                                                                            yearGroup?.reportHeaders.map((header: any) => {
                                                                                // Find matching group in this period
                                                                                const matchingGroup = header?.reportGroups?.find(
                                                                                    (g: any) => g?.groupName === group?.groupName
                                                                                );
                                                                                // Find matching action in this group
                                                                                const matchingAction = matchingGroup?.subHeadings?.find(
                                                                                    (s: any) => s?.actionName === sub?.actionName
                                                                                );

                                                                                return (
                                                                                    <React.Fragment key={`data-${yearGroup.yearName}-${header.headerName}`}>
                                                                                        <td>{matchingAction?.count || '-'}</td>
                                                                                        <td>{matchingAction?.volume || '-'}</td>
                                                                                    </React.Fragment>
                                                                                );
                                                                            })
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </React.Fragment>
                                                        ))}
                                                    </tbody>
                                                </table>
                                                <div className="mt-3">
                                                    <p><strong>Notes:</strong> <br />Volume represents Contract Sale Price for all Actions and Currently Outstanding Permits</p>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <p>
                                                            <strong>Disclaimer:</strong> <br /> AFD data as of July/16/2025 3:21:59 PM<br />
                                                            Some YTD data is incomplete due to unavailability of data
                                                        </p>
                                                        <p className="fw-600">Airoom Confidential. Copyright 2006, Airoom, LLC</p>
                                                    </div>
                                                </div>
                                            </>
                                        </div>
                                    </div>
                                </div>
                            ) : !enterpriseData?.result ? (
                                <div>
                                    {/* <h5 className='color-red'>Please Select Date to show Enterprise report</h5> */}
                                </div>
                            )
                                : null}
                    </div>
                </div>
            </div >
        </>
    )
}

export default EnterPriseReport
